import http from "./http";
import user from "./user";
import localStorage from "./localStorage";
import config from "./config";
import download from "./download";
import notifyModule from "@/components/general/Notification.js";
import promptModal from "@/components/general/PromptModal.js";

import router from "../router";

export default {
  install: Vue => {
    Vue.prototype.$http = http;
    Vue.prototype.$http.interceptors.response.use(
      response => {
        return {
          ...response.data,
          statusCode: response.status,
          statusText: response.statusText,
        };
      },
      error => {
        const exceptions = [
          "Invalid token: access token has expired",
          "Invalid token: access token is invalid",
        ];

        if (!error.response) {
          return Promise.reject(error);
        }

        if (exceptions.includes(error.response.data.message)) {
          user.clearToken();
          error.response.data.message =
            "Your session expired. Kindly login to continue";
          const lastPageVisited = {
            path: router.currentRoute.path,
            params: router.currentRoute.params,
          };

          if (localStorage.set("lastPageVisited", lastPageVisited)) {
            router.push({ name: "login" });
          }
        }

        if (
          Object.keys(error.response.data).includes("errors") &&
          Array.isArray(error.response.data.errors)
        ) {
          const errorMessages = error.response.data.errors.map(
            error => error.message
          );
          const initialMessage = error.response.data.message;
          error.response.data.message = `${initialMessage} <br><br> ${errorMessages.join(
            "\n"
          )}`;
        }

        return Promise.reject({
          ...error.response.data,
          statusCode: error.response.status,
          statusText: error.response.statusText,
        }); //always reject error
      }
    );

    Vue.$http = Vue.prototype.$http;

    Vue.prototype.$user = user;
    Vue.$user = user;

    Vue.prototype.$notification = notifyModule;
    Vue.$notification = notifyModule;

    Vue.prototype.$localStorage = localStorage;
    Vue.$localStorage = localStorage;

    Vue.prototype.$config = config;
    Vue.$config = config;

    Vue.prototype.$download = download;
    Vue.$download = download;

    Vue.prototype.$promptModal = promptModal;
    Vue.$promptModal = promptModal;
  },
};
